<template>
  <div :class="['status-tag', itemData.status]" :style="itemData.style">
    {{ itemData.label }}
  </div>
</template>
<script>
export default {
  name: 'StatusTag',
  props: [
    'value',
    /**
     * 选项数组
     * @type {value?: string, label?: string, getLabel?: () => string, status?: 'primary'| 'success' | 'danger' | 'warning' | 'info', backgroundColor?: string, textColor?: string}[]
     * @default []
     *  */
    'options',
    'valueKey',
    'labelKey'
  ],
  computed: {
    itemData() {
      let valueKey = this.valueKey || 'value'
      const item = this.options.find(item => item?.[valueKey] === this.value)
      let label = ''
      if (item?.getLabel) {
        label = item.getLabel()
      } else {
        let labelKey = this.labelKey || 'label'
        label = item?.[labelKey]
      }
      const style = {}
      if (item?.backgroundColor) {
        style.backgroundColor = item.backgroundColor
        style.color = item.textColor
      }
      return {
        label: label || this.value,
        value: this.value,
        status: item ? item?.status : 'info',
        style: style
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.status-tag {
  margin: auto;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  background: $--color-info-bg;
  color: $--color-info;
  &.success {
    background: $--color-success-bg;
    color: $--color-success;
  }
  &.danger {
    background: $--color-danger-bg;
    color: $--color-danger;
  }
  &.warning {
    background: $--color-warning-bg;
    color: $--color-warning;
  }
  &.info {
    background: $--color-info-bg;
    color: $--color-info;
  }
  &.primary {
    background: $--color-primary-bg;
    color: $--color-primary;
  }
}
</style>
